import { BaseEntity } from 'entities';
import { AttachmentAttributes } from 'entities/attachment_attributes';
import { Instrument } from 'entities/instrument';
import { Laboratory } from 'entities/laboratory';
import { ReservationTerm, ReservationTermForm } from 'entities/reservation_term';
import { SearchQuery } from 'rac';

/**
 * 部屋
 */
export type Room = BaseEntity & {
  name?: string;
  proprietaryFlag?: boolean;
  canReserve?: boolean;
  imageUrl?: string;
  note?: string;

  laboratory?: Laboratory;
  laboratoryId?: number;
  reservationTerm?: ReservationTerm;
  instruments?: Instrument[];
};

export type RoomForm = Room & {
  reservationTermAttributes?: ReservationTermForm;
  imageAttributes?: AttachmentAttributes;
  cancelPolicyId?: number;
};

// TODO: 編集フォームを実装する際は entities/instrument.ts のコメントと実装を参考に、同様の構造で実装する

export type RoomSearchForm = {
  searchText?: string;
  expand?: boolean;
};

export const getRoomSearchQuery = (searchText?: string): SearchQuery => ({
  suffix: 'Cont',
  searchText: searchText || '',
  attrs: ['name', 'note'],
});
